module.exports = __webpack_public_path__ + "static/media/speech-bubble.b32e6dcb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/speech-bubble.svg
// module id = 1952
// module chunks = 0